import { Helmet } from "react-helmet-async";

// Reading env variables
const TITLE = process.env.REACT_APP_META_TITLE;
const DESCRIPTION = process.env.REACT_APP_META_DESCRIPTION;
const URL = process.env.REACT_APP_META_URL;
const IMAGE = process.env.REACT_APP_META_IMAGE;
const TYPE = process.env.REACT_APP_META_TYPE;

export default function SEO({
    title = TITLE,
    isCrawlable = true,
    description = DESCRIPTION,
    image = IMAGE,
    url = URL,
    type = TYPE,
}) {

    return (
        <Helmet>
            {/* Standard SEO */}
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
            {!isCrawlable && <meta name="robots" content="noindex, follow" />}
            <meta name="url" content={url} />
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={description} />
            <meta name="image" content={image} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />

            {/* Twitter */}
            <meta name="twitter:card" content={image} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
}
